export default __webpack_public_path__ + "static/media/logo.7dae9582.svg";